import React from 'react'
import GigButton from '../GigButton'
import MediaMenu from '../MediaMenu'
import Layouts from '../Layouts'
import componentStyles from './PresenterActions.module.scss'

const PresenterActions = () => (
  <div className={componentStyles[`actions`]}>
    <GigButton />
    <MediaMenu />
    <Layouts />
  </div>
)

export default PresenterActions
